// extracted by mini-css-extract-plugin
export default {"Tile":"tile_Tile__fq2hy"};